import { render, staticRenderFns } from "./PackageDetailsTooltip.vue?vue&type=template&id=e482ae70&scoped=true"
import script from "./PackageDetailsTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageDetailsTooltip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PackageDetailsTooltip.vue?vue&type=style&index=0&id=e482ae70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e482ae70",
  null
  
)

export default component.exports